/**
 * Where the API is, from the build-time environment. Empty means the same origin as the page.
 *
 * In production this is the API server's origin (the manifest then points content at the edge). In
 * development it is a server run in CDN mode, whose manifest reports the live CDN, so the dev app
 * reads pre-gated content from the edge and never serves raw ungated artifacts itself.
 */
export const defaultApiBase = import.meta.env.VITE_API_BASE ?? '';

/**
 * DRAW THE MAP FROM ITS OWN ARTIFACT RATHER THAN FROM THE BUNDLE — `ARCHITECTURE.md D26`.
 *
 * Off by default, and a flag rather than a switch-over, because `DELIVERY.md §12` runs both paths side
 * by side until the new one is proven: the bundle still carries everything, so a reader loses nothing
 * if the skeleton is missing, and nothing is deleted until the new path has served real traffic.
 *
 * Build-time, like `VITE_API_BASE`, because it decides what the app fetches on its very first paint —
 * a runtime toggle would mean shipping both load paths and choosing between them after the moment
 * they matter.
 */
export const chunkedMap = import.meta.env.VITE_CHUNKED_MAP === '1';
